
// **** Better way to set special products in one place **** ////
var specialProduct1 = false;
var specialProduct2 = false;
var specialProduct3 = false;

for (var i = 0; i < crItems.length; i++ ){
  var itemCollections = crItems[i].collections
  var itemTitle = crItems[i].name;
  if (itemTitle === 'Pickup Instore') continue;
  //console.log({itemTitle})  
  console.log('-->', itemCollections)
 
  if (itemCollections.toLowerCase().indexOf('Christmas Shop'.toLowerCase()) > -1) {
    specialProduct1 = true;
  } 

  if (itemCollections.toLowerCase().indexOf('Local Meat'.toLowerCase()) > -1) {
    specialProduct1 = true;
  } 

  if (itemCollections.toLowerCase().indexOf('Brocksbushes Hampers'.toLowerCase()) > -1) {
    specialProduct1 = true;
  } 


  if (itemCollections.toLowerCase().indexOf('Delicious Deserts'.toLowerCase()) > -1) {
    specialProduct1 = true;
  } 

  if (itemCollections.toLowerCase().indexOf('From our Deli'.toLowerCase()) > -1) {
    specialProduct1 = true;
  } 

  if (itemCollections.toLowerCase().indexOf('Christmas Poultry'.toLowerCase()) > -1) {
    specialProduct1 = true;
  } 

  if (itemCollections.toLowerCase().indexOf('Buffet Favourites'.toLowerCase()) > -1) {
    specialProduct1 = true;
  } 

  if (itemCollections.toLowerCase().indexOf('From our Butchery'.toLowerCase()) > -1) {
    specialProduct1 = true;
  } 

  if (itemCollections.toLowerCase().indexOf('All the Trimmings'.toLowerCase()) > -1) {
    specialProduct1 = true;
  } 

  if (itemTitle.toLowerCase().indexOf('s Day Celebration Cake'.toLowerCase()) > -1) {
    specialProduct2 = true;
  } 

  if (itemTitle.toLowerCase().indexOf('s Day Afternoon Tea'.toLowerCase()) > -1) {
    specialProduct2 = true;
  }
  
  if (itemTitle.toLowerCase().indexOf('French Fancies (Box of 4)'.toLowerCase()) > -1) {
    specialProduct2 = true;
  }

  if (itemTitle.toLowerCase().indexOf('Father'.toLowerCase()) > -1) {
    specialProduct3 = true;
  }
}

var crDateCallback = function(picker, selectedStore, blackoutdatesCollection){
  if (specialProduct3 === true) {  	
    picker.set('disable', [true, 
        { from: [2020, 8, 10], to: [2026, 5, 18] }, 
        { from: [2026, 5, 22], to: [2035, 9, 7] }
    ]);
    picker.set('min', 2);   
  }	else 
  if (specialProduct2 === true) {  	
    picker.set('disable', [true, 
        { from: [2020, 8, 10], to: [2026, 2, 12] }, 
        { from: [2026, 2, 16], to: [2035, 9, 7] }
    ]);
    picker.set('min', 2);   
  }	else 
  if (specialProduct1 === true) {
  	picker.set('disable', [true, 
        { from: [2020, 8, 10], to: [2026, 11, 20] }, 
        { from: [2026, 11, 24], to: [2045, 9, 7] }
    ]);
    picker.set('max', 100);   
  }	else {
    picker.set('disable', blackoutdatesCollection);
  }  
}